export default "__VITE_ASSET__CjkwqI80__"